import { Rule } from "@siteimprove/alfa-act";
import { audio } from "../common/applicability/audio.js";
import { audioTranscript } from "../common/expectation/media-transcript.js";
import { Scope, Stability } from "../tags/index.js";
export default Rule.Atomic.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r23",
    tags: [Scope.Component, Stability.Stable],
    evaluate({ document, device }) {
        return {
            applicability() {
                return audio(document, device);
            },
            expectations(target) {
                return audioTranscript(target, device);
            },
        };
    },
});
//# sourceMappingURL=rule.js.map